<div class="item" *ngFor="let item of items">
    <span class="item_title">{{ item.label }} : </span>
    <span *ngIf="!params.isEstimatedProfit && item.type !== 'date'" class="item_value">{{ (item.number) || 'N/A' }}</span>
    <span class="item_value" *ngIf="item.type == 'date' && !params.isEstimatedProfit" > {{ item.number | date:'MM/dd/yy'}}</span> 
    <i *ngIf="(params.isShipment && item.isReceived  && params.selectedTab === 'closed')"
        matTooltip="The amount doesn't match the amount shipped"
        class="fal fa-exclamation-triangle text-danger ms-2"></i>
    <ng-container *ngIf="params.isEstimatedProfit">
        <span class="item_value" *ngIf="item.type !== 'currency'"   
        [ngClass]="{'item_valueNegative': item.number < 0}" >
        {{ (item.number) || 0 }}%
    </span>
        <span class="item_value" *ngIf="item.type == 'currency'"   
        [ngClass]="{'item_valueNegative': item.number < 0 }" >
        {{ (item.number) ||  '$' + 0 }}</span>
        <span *ngIf="params.isEstimatedProfit && item.label =='Profit' " class="item--clickable hand" [matMenuTriggerFor]="netProfitIsEstimatedProfit" >
            <i class="fas fa-chevron-down"></i>
    </span>
    </ng-container>   
    <span class="info" *ngIf="item?.showIcon">
        <i class="fas fa-info-circle ms-1" (mouseover)="openDialog($event,item.label,item?.showIcon)" (mouseout)="closeDialog($event)"></i> 
    </span>
</div>

<mat-menu #netProfitIsEstimatedProfit="matMenu" xPosition="before" class="netProfitDialog">  
    <div class="item-dropdown">
        <div class="item">
            <div class="item_group"> 
                <span class="item_value">Sale Price</span>
                <span class="item_value">{{(params.data.Price || 0) | currency}}</span>
            </div>
            <div class="item_group"> 
                <span class="item_value">FBA Fees </span>
                <span class="item_value">-{{(params.data.FBAFee || 0) | currency}}</span>
            </div>
        
            <div class="item_group"> 
                <span class="item_value">Referral Fees </span>
                <span class="item_value">-{{(params.data.ReferralFee || 0) | currency}}</span>
            </div>      
            <div class="item_group"> 
                <span class="item_value">Storage Fees </span>
                <span class="item_value">-{{(params.data.StorageFees || 0) | currency}}</span>
            </div>   
            <div class="item_group"> 
                <span class="item_value">Avg Cost </span>
                <span class="item_value">-{{(params?.data?.CostPr || 0) | currency}}</span>
            </div>
        </div>
    </div>
</mat-menu> 